import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";

export default function DashboardGrupos() {
  const [grupos, setGrupos] = useState([]);
  const [convites, setConvites] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      // CORREÇÃO: endpoints certos
      const r1 = await api.get("/grupos/"); // meus grupos
      const r2 = await api.get("/grupos/convites/"); // convites pendentes

      setGrupos(r1.data);
      setConvites(r2.data);
    } catch (error) {
      console.error("Erro ao carregar grupos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="card shadow-sm p-3 mb-3">
        <h5>Meus grupos</h5>
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <div className="card shadow-sm p-3 mb-4">
      <div className="d-flex justify-content-between mb-3">
        <h5 className="fw-bold">Meus grupos</h5>

        <div>
          <Link
              to="/grupos/convites"
              className="btn btn-outline-secondary btn-sm me-2"
          >
              Convites ({convites.length})
          </Link>

          <Link
              to="/grupos/buscar"
              className="btn btn-outline-primary btn-sm me-2"
          >
              Buscar grupo
          </Link>

          <Link
              to="/grupos/novo"
              className="btn btn-primary btn-sm"
          >
              Criar grupo
          </Link>
        </div>
      </div>

      {grupos.length === 0 && <p>Nenhum grupo encontrado.</p>}

      <div className="list-group">
        {grupos.map((g) => (
          <Link
            to={`/grupos/${g.id}`}
            key={g.id}
            className="list-group-item list-group-item-action d-flex align-items-center"
          >
            <img
              src={g.imagem_capa || "/grupo-default.png"}
              width={45}
              height={45}
              className="rounded-circle me-3"
              style={{ objectFit: "cover" }}
              alt={g.nome}
            />
            <div>
              <strong>{g.nome}</strong>
              <div className="text-muted small">{g.membros_ativos} membros ativos</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
